import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncTidalToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.syncTidalToYoutube}
            sections={<PairSyncGuideContent sourceKey="tidal" destKey="youtube" />}
        />
    );
}
